module.exports = __webpack_public_path__ + "static/img/5.41f78786.png";